import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeriesDocumentsComponent } from './series-documents.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { AddSectionComponent } from './add-section/add-section.component';
import { EditSectionComponent } from './edit-section/edit-section.component';
import { ChangeCurrentNumberComponent } from './change-current-number/change-current-number.component';

@NgModule({
    declarations: [
        SeriesDocumentsComponent,
        AddSectionComponent,
        EditSectionComponent,
        ChangeCurrentNumberComponent
    ],
    imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule],
    exports: [
        SeriesDocumentsComponent,
    ],
})
export class SeriesDocumentsModule { }
